import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { PaymentRedirectedComponent } from '../payments/payment-redirected/payment-redirected.component';
import {
  PaymentRequestUrlInvalidComponent
} from '../payments/payment-request-url-invalid/payment-request-url-invalid.component';
import { PaymentsRoutingModule } from './payments-routing.module';
import { HostedPaymentRequestComponent } from './hosted-payment-request/hosted-payment-request.component';
import { PaymentSelectionComponent } from './payment-selection/payment-selection.component';

@NgModule({
  imports: [
    CommonModule,
    PaymentsRoutingModule,
    NgxPaginationModule,
    SharedModule
  ],
  declarations: [
    PaymentRequestUrlInvalidComponent,
    PaymentRedirectedComponent,
    HostedPaymentRequestComponent,
    PaymentSelectionComponent
  ],
  entryComponents: [
    PaymentRequestUrlInvalidComponent,
    PaymentRedirectedComponent,
    HostedPaymentRequestComponent,
    PaymentSelectionComponent
  ]

})
export class PaymentsModule {
}
